<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>

    <div class="relative">
      <input 
        ref="input" 
        :id="id" 
        v-bind="{ ...$attrs, class: null }" 
        class="form-input" 
        :class="{ error: error }" 
        :type="type" 
        v-model="timevalue"
        v-mask="'##:##'" />

      <button 
        type="button" 
        class="absolute right-0" 
        @click.prevent="$e => this.$refs.timepicker.openMenu()">
          <font-awesome-icon icon="fa-regular fa-calendar" />
      </button>
    </div>

    <Datepicker 
      ref="timepicker" 
      modelType="HH:mm" 
      autoApply
      :class="{ error: error }" 
      time-picker
      locale="pt-BR"
      :clearable="false"
      @internal-model-change="handleChangeTime">
        <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
        </template>
    </Datepicker>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import ptBR from 'date-fns/locale/pt-BR'
import { mask } from 'vue-the-mask'

import { ref } from 'vue'

export default {
  directives: { mask },
  components: { Datepicker, ptBR, },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
  },
  emits: ['update:modelValue'],
  
  setup( props, ctx ) {
    const timevalue = ref( props.modelValue )
    const error = ref( props.error )

    const handleChangeTime = event => {
      if ( event )
        timevalue.value = `${ event.getHours() }:${ event.getMinutes() }`
    }

    return { timevalue, error, handleChangeTime }
  }
}
</script>
